"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[607,475],{

/***/ 6475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _Image__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4297);



/***/ }),

/***/ 7607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ulupinar_contact_UlupinarContact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
// EXTERNAL MODULE: ./components/base/image/index.tsx
var base_image = __webpack_require__(6475);
// EXTERNAL MODULE: ./services/http/wap/http.ts
var http = __webpack_require__(889);
;// CONCATENATED MODULE: ./services/http/wap/query/endpoints.ts

var run = function(environment, params) {
    return request(environment, {
        method: 'get',
        url: "/queries/".concat(params.language, "/").concat(params.name, "/run?").concat(params.query || '')
    });
};
var runForm = function(environment, params, data) {
    return (0,http/* request */.W)(environment, {
        method: 'post',
        url: "/queries/".concat(params.language, "/").concat(params.name, "/run?").concat(params.query || ''),
        data: data
    });
};

// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/widgets/ulupinar-contact/UlupinarContact.tsx







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var UlupinarContact = function(param) {
    var contactimage = param.contactimage, location = param.location, phone = param.phone, inputimage = param.inputimage, faks = param.faks;
    var app = (0,contexts_app/* useApp */.qD)();
    var ref = (0,react.useState)('default'), formStatus = ref[0], setFormStatus = ref[1];
    var ref1 = (0,react.useState)(false), loadingState = ref1[0], setloadingState = ref1[1];
    var ref2 = (0,react.useState)({}), formValues = ref2[0], setFormValues = ref2[1];
    (0,react.useEffect)(function() {
        formStatus && setloadingState(false);
    // formValues.map((input) => (input.value = ''))
    }, [
        formStatus
    ]);
    var onSubmit = function(e) {
        e.preventDefault();
        setloadingState(true);
        var formDataArray = [
            {
                name: 'ePosta',
                data: {
                    refs: [],
                    value: formValues.email
                }
            },
            {
                name: 'soyisim',
                data: {
                    refs: [],
                    value: formValues.surname
                }
            },
            {
                name: 'iSim',
                data: {
                    refs: [],
                    value: formValues.name
                }
            },
            {
                name: 'baslik',
                data: {
                    refs: [],
                    value: formValues.name + ' ' + formValues.surname
                }
            },
            {
                name: 'message',
                data: {
                    refs: [],
                    value: formValues.message
                }
            }, 
        ];
        var requestBody = {
            parameters: null,
            columns: formDataArray
        };
        runForm(app.environment, {
            name: 'iletisim-formu-create-veri-sorgusu-2',
            language: app.language
        }, requestBody).then(function(response) {
            if (response.data.id) {
                setFormStatus('success');
                setTimeout(function() {
                    setFormStatus('default');
                    setFormValues({
                        name: '',
                        surname: '',
                        email: '',
                        message: ''
                    });
                }, 2000);
            }
            setloadingState(false);
        }).catch(function() {
            setFormStatus('error');
            setTimeout(function() {
                return setFormStatus('default');
            }, 2000);
            setloadingState(false);
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ulupinar-contact",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "ulupinar-contact-main",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ulupinar-contact-main-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ulupinar-contact-main-page-items",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Container */.W2, {
                            size: "medium",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                                        xs: {
                                            size: 12
                                        },
                                        sm: {
                                            size: 12
                                        },
                                        md: {
                                            size: 12
                                        },
                                        lg: {
                                            size: 12
                                        },
                                        xl: {
                                            size: 12
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ulupinar-contact-image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({
                                                    className: "full-image"
                                                }, contactimage, {
                                                    alt: ""
                                                }))
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                                        xs: {
                                            size: 12
                                        },
                                        sm: {
                                            size: 12
                                        },
                                        md: {
                                            size: 12
                                        },
                                        lg: {
                                            size: 12
                                        },
                                        xl: {
                                            size: 12
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "ulupinar-contact-main-page-items-info",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ulupinar-contact-location",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: app.settings.translations['address']
                                                        }),
                                                        location
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ulupinar-contact-phone",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: app.settings.translations['phone']
                                                        }),
                                                        phone
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ulupinar-contact-faks",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: app.settings.translations['faks']
                                                        }),
                                                        faks
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: onSubmit,
                        className: "ulupinar-contact-input",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
                            size: "medium",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Row */.X2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                                        xs: {
                                            size: 12
                                        },
                                        sm: {
                                            size: 12
                                        },
                                        md: {
                                            size: 12
                                        },
                                        lg: {
                                            size: 8
                                        },
                                        xl: {
                                            size: 8
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "direction",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ulupinar-contact-input-withus",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: app.settings.translations['contact-withus']
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ulupinar-contact-input-contact-fill",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        style: {
                                                            fontWeight: '400'
                                                        },
                                                        children: app.settings.translations['fill']
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    required: true,
                                                    type: "text",
                                                    name: "name",
                                                    placeholder: app.settings.translations['name'],
                                                    onChange: function(e) {
                                                        setFormValues(_objectSpread({}, formValues, {
                                                            name: e.target.value
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    required: true,
                                                    type: "text",
                                                    name: "surname",
                                                    placeholder: app.settings.translations['surname'],
                                                    onChange: function(e) {
                                                        setFormValues(_objectSpread({}, formValues, {
                                                            surname: e.target.value
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    required: true,
                                                    type: "email",
                                                    name: "email",
                                                    placeholder: app.settings.translations['email-address'],
                                                    onChange: function(e) {
                                                        setFormValues(_objectSpread({}, formValues, {
                                                            email: e.target.value
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    required: true,
                                                    placeholder: app.settings.translations['message-placeholder'],
                                                    onChange: function(e) {
                                                        setFormValues(_objectSpread({}, formValues, {
                                                            message: e.target.value
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,functions.classnames)('alert-message', formStatus === 'success' ? 'alert-message--success alert-message--active' : '', formStatus === 'error' ? 'alert-message--error alert-message--active' : ''),
                                                    children: function() {
                                                        switch(formStatus){
                                                            case 'success':
                                                                return app.settings.translations['success.message'];
                                                            case 'error':
                                                                return app.settings.translations['error.message'];
                                                            default:
                                                                return null;
                                                        }
                                                    }()
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "submit",
                                                    type: "submit",
                                                    children: app.settings.translations['send']
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                                        xs: {
                                            size: 12
                                        },
                                        sm: {
                                            size: 12
                                        },
                                        md: {
                                            size: 12
                                        },
                                        lg: {
                                            size: 4
                                        },
                                        xl: {
                                            size: 4
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ulupinar-input-image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({}, inputimage, {
                                                    alt: ""
                                                }))
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var ulupinar_contact_UlupinarContact = (UlupinarContact);

;// CONCATENATED MODULE: ./components/widgets/ulupinar-contact/index.ts



/***/ }),

/***/ 889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ request; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6154);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function request(environment, config, mappers) {
    if (mappers) {
        if (config.params && mappers.params) {
            config.params = mappers.params(config.params);
        }
        if (config.data && mappers.req) {
            config.data = mappers.req(config.data);
        }
    }
    return new Promise(function(resolve, reject) {
        axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].request */ .Z.request(_objectSpread({
            baseURL: environment.service
        }, config)).then(function(res) {
            if (mappers && mappers.res) {
                try {
                    resolve(mappers.res(res.data));
                } catch (err) {
                    console.log('errwwww', err);
                    reject({
                        code: 406,
                        type: err.name,
                        message: err.message
                    });
                }
            } else {
                resolve(res.data);
            }
        }).catch(function(err) {
            if (err.response) {
                console.log('err222.response', err.response);
                reject({
                    code: err.response.status,
                    type: err.response.statusText,
                    message: err.message
                });
            } else {
                reject({
                    code: 503,
                    type: 'Service Unavailable',
                    message: 'The server cannot be reached.'
                });
            }
        });
    });
}


/***/ })

}]);